import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const OTHER_FEES_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.otherFeesDescription,
    sortsOn: AssetColumns.otherFeesDescription,
    tooltip: CatalogReferenceDataSlugs.other_fees_description,
    label: "Other Fees",
    type: ColumnTypes.string,
    width: 160,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    cellValue: (item) => {
        if (item.isAsset) {
            return item.other_fees_description || null;
        }

        return null;
    },
};
